import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export type ContainerProps = {
    alignment: string
    loaded: boolean
}

export const Container = styled("ul", {
    shouldForwardProp: prop => !["loaded", "alignment"].includes(prop as string),
})<ContainerProps>`
    width: 100%;
    height: 100%;
    border-top-style: none;
    display: flex;
    opacity: var(--display-primary-nav, 0);
    align-items: center;
    flex-direction: row;
    padding: 0 0.5rem;
    margin: 0;
    -ms-overflow-style: none;
    overflow-x: scroll;
    overflow-y: hidden;
    scroll-behavior: ${({loaded}) => (loaded ? "smooth" : "auto")};
    -ms-overflow-style: none; /* Internet Explorer 10+ */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
        display: none;
    }

    @media (min-width: ${breakpoints.values.md}px) {
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }

    @media (min-width: ${breakpoints.values.xl}px) {
        max-width: 1200px;
        margin: 0 auto;
        padding: 0;
    }
`
